import { render, staticRenderFns } from "./userAddresses.vue?vue&type=template&id=7a0a6578&scoped=true&"
import script from "./userAddresses.vue?vue&type=script&lang=js&"
export * from "./userAddresses.vue?vue&type=script&lang=js&"
import style0 from "./userAddresses.vue?vue&type=style&index=0&id=7a0a6578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0a6578",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a0a6578')) {
      api.createRecord('7a0a6578', component.options)
    } else {
      api.reload('7a0a6578', component.options)
    }
    module.hot.accept("./userAddresses.vue?vue&type=template&id=7a0a6578&scoped=true&", function () {
      api.rerender('7a0a6578', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/userAddresses.vue"
export default component.exports